// How each kind of agent looks. THE ONE PLACE TO CUSTOMIZE AN AGENT'S FACE.
//
// A look is a set of parts, not a drawing: the eyes, the bulb and the three
// cells are always there, because they carry the STATE (working, expired,
// idle…) and every kind has to be able to show every state. What a kind picks
// is everything around them:
//
//   tone    which `--mm-agent-*` token inks the outline (design/paleta.md §8)
//   head    'round' | 'square'
//   top     'mast'  — a single antenna with the bulb on top
//           'crown' — three points, the bulb above the middle one
//           'none'  — the bulb sits on the head
//   ears    the side stubs that read as hardware
//   brow    a line over the eyes — stern, for whoever reviews
//   prompt  a `>` at the left of the mouth — a terminal, not a worker
//
// Silhouettes differ BEFORE colours do: somebody who cannot tell violet from
// blue still tells a crown from an antenna. Adding a kind is adding an entry;
// a kind the backend invents tomorrow falls back to `other` instead of a hole.

export const AGENT_LOOKS = {
    // Plans, breaks tiers down and reviews. It does not take tasks.
    agent_master: { tone: 'master', head: 'round',  top: 'crown', ears: true,  brow: true,  prompt: false },
    // Takes tasks and delivers them.
    agent_slave:  { tone: 'slave',  head: 'round',  top: 'mast',  ears: true,  brow: false, prompt: false },
    // Read-only, for a command-line tool.
    cli:          { tone: 'cli',    head: 'square', top: 'none',  ears: false, brow: false, prompt: true },
};

const OTHER = { tone: 'other', head: 'round', top: 'mast', ears: true, brow: false, prompt: false };

// Null kind means the caller does not know it, which is not the same as an
// unknown kind: the face keeps its neutral ink and claims nothing.
export function agentLook(kind) {
    if (kind == null) return null;
    return AGENT_LOOKS[kind] ?? OTHER;
}
